import Page from "../../components/Page.jsx";
import useTagPage from "./hooks/useTagPage.js";

const TagPage = () => {
  const page = useTagPage();
  return <Page {...page} />;
};

export default TagPage;
